import React, { useState } from 'react';
import api from '../services/api';

const SincronizacaoManualNFSe = ({ onSuccess, onError, onClose, hideButton = false, isFloating = false }) => {
    const [chaveAcesso, setChaveAcesso] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [localMessage, setLocalMessage] = useState('');
    const [messageType, setMessageType] = useState(''); // 'error' ou 'info'

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLocalMessage(''); // Limpa mensagens anteriores
        
        // Remove espaços para validação e envio
        const chaveLimpa = chaveAcesso.replace(/ /g, '');
        
        if (!chaveLimpa.trim()) {
            setLocalMessage('Por favor, informe a chave de acesso da NFSe');
            setMessageType('error');
            return;
        }

        if (chaveLimpa.length < 20) {
            setLocalMessage('A chave de acesso informada é muito curta');
            setMessageType('error');
            return;
        }

        setIsLoading(true);
        
        try {
            const response = await api.post('/notasfiscaisservicos/sincronizar-chave', {
                chaveAcesso: chaveLimpa
            });
            
            const result = response.data;
            
            setChaveAcesso('');
            setShowModal(false);
            setLocalMessage('');
            
            // Fechar modal se estiver sendo usado no botão flutuante
            if (onClose) {
                onClose();
            }
            
            // Criar mensagem mais detalhada para o modal de sucesso
            let successMessage = result.message || 'NFSe importada com sucesso!';
            
            if (result.data) {
                successMessage += `\n\nChave: ${result.data.chave}`;
                if (result.data.observacao) {
                    successMessage += `\n\n${result.data.observacao}`;
                }
            }
            
            onSuccess && onSuccess(successMessage);
            
        } catch (error) {
            console.error('Erro na sincronização:', error);
            
            const errorMessage = error.response?.data?.message || 
                               error.response?.data?.error || 
                               'Erro ao sincronizar NFSe';
            
            setLocalMessage(errorMessage);
            setMessageType('error');
        } finally {
            setIsLoading(false);
        }
    };

    const handleChaveChange = (e) => {
        // Sem processamento automático - apenas atualiza o valor
        setChaveAcesso(e.target.value);
        
        // Limpar mensagem de validação quando o usuário começar a digitar
        if (localMessage) {
            setLocalMessage('');
            setMessageType('');
        }
    };

    const limparEspacos = () => {
        // Remove apenas espaços quando o usuário clicar no botão
        const chaveLimpa = chaveAcesso.replace(/ /g, '');
        setChaveAcesso(chaveLimpa);
    };

    const handleCancel = () => {
        setChaveAcesso('');
        setLocalMessage('');
        setMessageType('');
        setShowModal(false);
        
        // Fechar modal se estiver sendo usado no botão flutuante
        if (onClose) {
            onClose();
        }
    };

    return (
        <>
            {/* Botão para abrir o modal - só mostra se hideButton for false */}
            {!hideButton && (
                <button
                    onClick={() => setShowModal(true)}
                    className={isFloating 
                        ? "w-14 h-14 bg-stone-600 hover:bg-stone-700 text-white rounded-full shadow-lg transition-all duration-300 flex items-center justify-center hover:scale-110"
                        : "bg-stone-600 hover:bg-stone-700 text-white px-4 py-2 rounded-md flex items-center gap-2 transition-colors shadow-sm"
                    }
                    title="Sincronizar NFSe manualmente por chave de acesso"
                >
                    <svg className={isFloating ? "w-6 h-6" : "w-4 h-4"} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                    </svg>
                    {!isFloating && <span className="text-sm">Sincronizar NFSe</span>}
                </button>
            )}

            {/* Modal - só mostra quando showModal for true E hideButton for false */}
            {showModal && !hideButton && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
                        <div className="flex justify-between items-center mb-4">
                            <h3 className="text-lg font-semibold text-gray-900">
                                Sincronizar NFSe
                            </h3>
                            <button
                                onClick={handleCancel}
                                className="text-gray-400 hover:text-gray-600"
                            >
                                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>

                        <form onSubmit={handleSubmit}>
                            <div className="mb-4">
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                    Chave de Acesso da NFSe
                                </label>
                                <div className="flex gap-2">
                                    <input
                                        type="text"
                                        value={chaveAcesso}
                                        onChange={handleChaveChange}
                                        placeholder="Digite a chave de acesso"
                                        className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent font-mono text-sm"
                                        disabled={isLoading}
                                    />
                                    {chaveAcesso.includes(' ') && (
                                        <button
                                            type="button"
                                            onClick={limparEspacos}
                                            className="px-3 py-2 text-sm bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-md"
                                            title="Remover espaços"
                                        >
                                            Limpar
                                        </button>
                                    )}
                                </div>
                                <p className="mt-1 text-xs text-gray-500">
                                    Exemplo: NFS33045572263783983000108000000000001126016937656680
                                </p>
                            </div>

                            {localMessage && (
                                <div className={`mb-4 p-3 rounded-md ${
                                    messageType === 'error' 
                                        ? 'bg-red-50 text-red-800 border border-red-200' 
                                        : 'bg-blue-50 text-blue-800 border border-blue-200'
                                }`}>
                                    <p className="text-sm">{localMessage}</p>
                                </div>
                            )}

                            <div className="flex justify-end gap-3">
                                <button
                                    type="button"
                                    onClick={handleCancel}
                                    className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md transition-colors"
                                    disabled={isLoading}
                                >
                                    Cancelar
                                </button>
                                <button
                                    type="submit"
                                    disabled={isLoading}
                                    className="px-4 py-2 text-sm font-medium text-white bg-stone-600 hover:bg-stone-700 rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
                                >
                                    {isLoading ? (
                                        <>
                                            <svg className="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                            </svg>
                                            Sincronizando...
                                        </>
                                    ) : (
                                        'Sincronizar'
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* Formulário inline quando hideButton = true */}
            {hideButton && (
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Chave de Acesso da NFSe
                        </label>
                        <div className="flex gap-2">
                            <input
                                type="text"
                                value={chaveAcesso}
                                onChange={handleChaveChange}
                                placeholder="Digite a chave de acesso"
                                className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent font-mono text-sm"
                                disabled={isLoading}
                            />
                            {chaveAcesso.includes(' ') && (
                                <button
                                    type="button"
                                    onClick={limparEspacos}
                                    className="px-3 py-2 text-sm bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-md"
                                    title="Remover espaços"
                                >
                                    Limpar
                                </button>
                            )}
                        </div>
                        <p className="mt-1 text-xs text-gray-500">
                            Exemplo: NFS33045572263783983000108000000000001126016937656680
                        </p>
                    </div>

                    {localMessage && (
                        <div className={`p-3 rounded-md ${
                            messageType === 'error' 
                                ? 'bg-red-50 text-red-800 border border-red-200' 
                                : 'bg-blue-50 text-blue-800 border border-blue-200'
                        }`}>
                            <p className="text-sm">{localMessage}</p>
                        </div>
                    )}

                    <div className="flex justify-end gap-3">
                        {onClose && (
                            <button
                                type="button"
                                onClick={onClose}
                                className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md transition-colors"
                                disabled={isLoading}
                            >
                                Cancelar
                            </button>
                        )}
                        <button
                            type="submit"
                            disabled={isLoading}
                            className="px-4 py-2 text-sm font-medium text-white bg-stone-600 hover:bg-stone-700 rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
                        >
                            {isLoading ? (
                                <>
                                    <svg className="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                    </svg>
                                    Sincronizando...
                                </>
                            ) : (
                                'Sincronizar'
                            )}
                        </button>
                    </div>
                </form>
            )}
        </>
    );
};

export default SincronizacaoManualNFSe;
